import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Table, Button, Modal, Input, Message } from 'antd'
import Popconfirm from '../../components/Popconfirm/Popconfirm2'
import EModal from './component/employeeModal'
import * as action from './action'
import { fetchQiniuToken, fetchQiniu } from '../ClubCommodity/action'
import { postRebindMember } from '../../api/employee'
import './index.css'

class ClubEmployeeManager extends React.Component {
  state = {
    isLoading: true,
    showDetail: false,
    staffDetail: null,
    isShowChangeMemberModal: false,
    chosenRecord: {},
    changeMemberId: '',
  }

  componentDidMount() {
    this.getOtherData()
    this.getDatas()
  }

  getDatas = async () => {
    await this.props.getStaffList()
    this.setState({ isLoading: false })
  }

  getOtherData = () => {
    this.props.fetchQiniuToken()
    this.props.getShiftList()
    this.props.allTemplateList()
    this.props.chargeTypeList()
    this.props.salaryTypeList()
  }

  editEmployeeDetail = async (id) => {
    this.setState({ isLoading: true })
    const data = await this.props.getStaffDetail(id)
    this.setState({ isLoading: false })
    if (data) {
      this.setState({ staffDetail: data, showDetail: true })
    }
  }

  deleteEmployee = async (id) => {
    this.setState({ isLoading: true })
    const res = await this.props.postDeleteEmployee(id)
    this.setState({ isLoading: false })
  }

  addEmployee = async () => {
    this.setState({
      staffDetail: null,
      showDetail: true,
    })
  }

  onCloseHandle = () => {
    this.setState({
      showDetail: false,
    })
  }

  // 换绑会员
  changeMember = async () => {
    const { changeMemberId } = this.state
    if (!changeMemberId) {
      Message.error('请输入要换绑的会员ld')
      return
    }
    const { data, status, detail } = await postRebindMember({
      employeeId: this.state.chosenRecord.employee.id,
      memberId: changeMemberId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    Message.success('换绑成功')
    this.props.getStaffList()
    this.changeMemberClose()
  }

  // 关闭换绑会员模态窗
  changeMemberClose = () => {
    this.setState({
      isShowChangeMemberModal: false,
      chosenRecord: {},
      changeMemberId: '',
    })
  }

  render() {
    const { tableList, shiftList, templateList, chargeList, salaryList } =
      this.props
    const { isLoading, showDetail, staffDetail } = this.state
    const columns = [
      {
        title: '员工ID',
        dataIndex: ['employee', 'id'],
        key: 'eid',
      },
      {
        title: '员工姓名',
        dataIndex: ['employee', 'name'],
        key: 'name',
      },
      {
        title: '员工职位',
        dataIndex: ['employee', 'jobTitle'],
        key: 'jobTitle',
      },
      {
        title: '员工手机号码',
        dataIndex: ['employee', 'phone'],
        key: 'phone',
      },
      {
        title: '绑定会员ID',
        dataIndex: ['member', 'id'],
        key: 'mid',
        render: (text, record, index) => {
          if (text == -1) {
            return '无绑定'
          } else {
            return text
          }
        },
      },
      {
        title: '绑定会员账户',
        dataIndex: ['member', 'account'],
        key: 'account',
      },
      {
        title: '绑定会员名',
        dataIndex: ['member', 'memberName'],
        key: 'nickName',
      },
      // {
      //   title: '考勤班次',
      //   dataIndex: 'workType',
      //   key: 'workType',
      // },
      // {
      //   title: '加入日期',
      //   dataIndex: 'inDate',
      //   key: 'inDate',
      // },
      // {
      //   title: '添加人',
      //   dataIndex: 'addPeople',
      //   key: 'addPeople',
      // },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Button
                type="primary"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  this.editEmployeeDetail(record.employee.id)
                }}
              >
                编辑
              </Button>
              {/* <Button
                type="primary"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  this.setState({
                    chosenRecord: record,
                    isShowChangeMemberModal: true,
                  })
                }}
              >
                换绑会员
              </Button> */}
              <Popconfirm
                title="你确认要删除此员工吗?"
                okText="确认"
                cancelText="取消"
                onConfirm={() => this.deleteEmployee(record.employee.id)}
              >
                <Button type="primary" danger>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]
    return (
      <div>
        <div style={{ marginBottom: '10px' }}>
          <Button
            type="primary"
            disabled={isLoading}
            onClick={this.addEmployee}
          >
            新增员工
          </Button>
        </div>
        <Table
          rowKey={(record, index) => index}
          loading={isLoading}
          bordered
          size="small"
          columns={columns}
          dataSource={tableList}
        />
        {showDetail && (
          <EModal
            qiniuToken={this.props.qiniuToken}
            sourceData={staffDetail}
            shiftList={shiftList}
            templateList={templateList}
            chargeList={chargeList}
            salaryList={salaryList}
            postPhotoToQiniu={this.props.fetchQiniu}
            getShiftList={this.props.getShiftList}
            obtainTemplateDetail={this.props.obtainTemplateDetail}
            saveEmployeeTemplate={this.props.saveEmployeeTemplate}
            addOrEditEmployee={this.props.postEmployeeDetail}
            onCloseEvent={this.onCloseHandle}
          ></EModal>
        )}

        <Modal
          visible={this.state.isShowChangeMemberModal}
          destroyOnClose
          title="换绑会员"
          width="400px"
          onOk={this.changeMember}
          onCancel={this.changeMemberClose}
        >
          <div>
            <Input
              placeholder="请输入你要换绑的会员ld"
              onChange={(e) => {
                this.setState({
                  changeMemberId: e.target.value,
                })
              }}
            ></Input>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tableList: state.getEmpManager.tableList, // 列表数据
    shiftList: state.getEmpManager.shiftList, // 班次列表
    templateList: state.getEmpManager.templateList, // 模板列表
    chargeList: state.getEmpManager.chargeList, // 收费类型
    salaryList: state.getEmpManager.salaryList, // 薪酬类型
    qiniuToken: state.getClubCommodity.qiniuToken,
  }
}

const mapDispatchToProps = {
  ...action,
  fetchQiniuToken,
  fetchQiniu,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClubEmployeeManager)
)



// WEBPACK FOOTER //
// ./src/containers/ClubEmployeeManager/index.js